import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';

/**
 * Super-Admin SPA entry point.
 *
 * MSAL redirect handling: @azure/msal-browser intercepts the OAuth
 * redirect on page load before React renders. No explicit handleRedirect
 * call is needed here — MsalProvider (in App.tsx) calls
 * msalInstance.initialize() and handleRedirectPromise() automatically.
 */

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element #root not found — check index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
